/**
 * Legal + support links, defined once for web and mobile.
 *
 * The Terms of Service and Privacy Policy themselves live on the marketing
 * site (quezadabrayan1/swipehome-site) — the apps only link to them, never
 * embed their text. Signup, login, and Profile → Legal all read from here.
 */
export const TERMS_URL = 'https://swipehomeapp.io/terms.html';
export const PRIVACY_URL = 'https://swipehomeapp.io/privacy.html';

/** Terms §2 / §12 and Privacy §6 route account + rights requests here. */
export const SUPPORT_EMAIL = 'support@swipehomeapp.io';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
